// Country-less form — Apple geo-redirects to the visitor's regional
// storefront automatically. Hard-coding `/us/` would force PL/DE/FR/etc.
// visitors through the US store. The numeric ID is the canonical key;
// the slug is cosmetic and survives renames.
export const IOS_APP_STORE_URL =
  "https://apps.apple.com/app/baiki/id6759352176";
